import { memo, useCallback } from "react";
import { cn } from "@/lib/utils";
import type { AvailableChartColorsKeys } from "@/lib/utils/chartUtils";
import { getColorClassName } from "@/lib/utils/chartUtils";
import { addCommasToNumbers } from "@/lib/utils/prettyName";
import { parseToolTipCategory } from "./feedVolumeGraphHelpers";
import type { FeedVolumeGraphToolTipMessageProps } from "./NewsFeedVolumeGraph.types";

const areTooltipMessagePropsEqual = (
  prev: FeedVolumeGraphToolTipMessageProps,
  next: FeedVolumeGraphToolTipMessageProps,
) =>
  prev.stackedBy === next.stackedBy &&
  prev.category === next.category &&
  prev.color === next.color &&
  prev.value === next.value;

const TooltipMessage = ({
  stackedBy,
  category,
  color,
  value,
}: FeedVolumeGraphToolTipMessageProps) => {
  const renderColorDot = useCallback(() => {
    return (
      <span
        aria-hidden="true"
        className={cn(
          "size-2 shrink-0 rounded-sm float-left mr-2 mt-1",
          getColorClassName(color as AvailableChartColorsKeys, "bg", "solid"),
        )}
      />
    );
  }, [color]);

  return (
    <div className="text-xs text-gray-700 mb-2">
      {stackedBy === null ? (
        <p className="text-sm">
          {renderColorDot()}
          <span className="font-semibold">{`${addCommasToNumbers(value ?? 0)} `}</span>
          articles
        </p>
      ) : (
        <div className="text-xs line-clamp-3 wrap-break-word leading-tight">
          {renderColorDot()}
          {stackedBy === "narrative_clusters"
            ? category
            : parseToolTipCategory(category)}
        </div>
      )}
    </div>
  );
};

TooltipMessage.displayName = "NewsFeedVolumeGraphToolTipMessage";
export const NewsFeedVolumeGraphToolTipMessage = memo(
  TooltipMessage,
  areTooltipMessagePropsEqual,
);
